import React, { ReactElement, useEffect, useState } from 'react'
import AppRouter from './AppRouter';
import Cookies from "js-cookie";

import { Provider } from "react-redux";
import store, { RootState, AppDispatch, getCurrentUserData, getAppWorkflowState, setAppRedirectURL, getAppRedirectURL, setAppWorkflowState, setBusinessParameterList } from "./Redux/store";
import { setCurrentUserData, useGetUserDataQuery } from "./Redux/User/userSlice";
import { useRefreshTokenQuery } from "./Redux/Admin_Tasks/AdminProcedureSlice";
import { useDispatch, useSelector } from 'react-redux';
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { FoundationsConstants } from './FoundationsConstants'
import useCookieWatcher from './Hooks/useCookieWatcher'

// TODO remove all uses of 'any'

import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { setPublicAppSetting, setProtectedAppSetting, useGetProtectedAppSettingsQuery, useGetPublicDataQuery, useGetReleaseNotesMutation } from './Redux/App/appSlice'
import { useResetRelasePopupMutation } from './Redux/Admin_Tasks/userAccountSlice';
import { useNavigate } from 'react-router-dom'
import { appWorkflowStates } from './Types/appWorkflowStates';
import { QueryStatus } from '@reduxjs/toolkit/query';
import { useInterval } from 'usehooks-ts';
import { ToastContainer } from './GenericComponents/FoundationsGenericToaster';
import { setHLUserCookies, startProxyCheckThread } from './GlobalMethods';
import { useGetAllBusinessParamsListQuery, useGetBusinessParametersMutation } from './Redux/VisualUnits/vuParamSlice';
import Overlay from './Pages/HomePage/Overlay';


const SetupAppContext = React.memo(({ children }: { children: React.ReactNode }) => {

  const cookieValue = useCookieWatcher(FoundationsConstants.TOKEN_STR, 1000, (oldCookieValue, newCookieValue) => {
    if (oldCookieValue != null && newCookieValue == null) {
      console.log("App.tsx: Cookie gone, setting appstatus")
      dispatch(setAppRedirectURL(window.location.hash));
      dispatch(setAppWorkflowState(appWorkflowStates.UNAUTHENTICATED));
    }
  }); // ✅ Triggers callback on cookie change

  const [lastTokenUpdatedTime, setLastTokenUpdatedTime] = useState<number>(Date.now());

  const dispatch = useDispatch();

  const [currentUserInsertedInState, setCurrentUserInsertedInState] = useState<boolean>(false);
  
  //    const { data: currentUser, refetch: refetchCurrentUserDataQuery } = useGetUserDataQuery(void 0,);

  const rawToken = useCookieWatcher(FoundationsConstants.TOKEN_STR);
  const tokenReady = typeof rawToken !== 'undefined';
  const { data: currentUser, status: currentUserStatus, refetch: refetchCurrentUser } = useGetUserDataQuery(void 0, { skip: !tokenReady });
  const { data: refreshTokenData, status: refreshTokenStatus, refetch: refetchRefreshToken } = useRefreshTokenQuery(void 0, {skip: !tokenReady,});
  const appWorkflowState = useSelector(
    (state: RootState) => getAppWorkflowState(state)
  )
  const appRedirectURL = useSelector(
    (state: RootState) => getAppRedirectURL(state)
  )

  const [displayOverlay,setDisplayOverlay] = useState(false)
  const [getReleaseNotes] = useGetReleaseNotesMutation();
  const [resetReleasePopup] = useResetRelasePopupMutation();
  useEffect(() => {

    if (appWorkflowState == null) {
      dispatch(setAppWorkflowState(appWorkflowStates.UNINITIALIZED));
    }
    if (currentUserStatus == QueryStatus.fulfilled) {
      dispatch(setCurrentUserData(currentUser));
      const favWorkspace = currentUser.data.UserFavWorkspace
      if (appWorkflowState == appWorkflowStates.JUST_AUTHENTICATED_APP_IN_LIMBO && currentUser.data.ForceUserToChangePassword) {
        let path = `${location.pathname}${location.search}#UserSettings`.replace("//", "/");
        dispatch(setAppRedirectURL(path))
        dispatch(setAppWorkflowState(appWorkflowStates.AUTHENTICATED));
        return;
      }
      if (appWorkflowState == appWorkflowStates.JUST_AUTHENTICATED_APP_IN_LIMBO) {
        let path = `${location.pathname}${location.search}#home`.replace("//", "/");
        if (appRedirectURL) { //URL Before Authentication
          path = appRedirectURL
          dispatch(setAppRedirectURL(null))
        } else {
          if (favWorkspace == 'home') {
            //Do nothing? :D
          } else {
            path = `${location.pathname}${location.search}#workspace/${favWorkspace}`;
          }
          dispatch(setAppRedirectURL(path))
        }
      }
      setLastTokenUpdatedTime(Date.now());
      dispatch(setAppWorkflowState(appWorkflowStates.AUTHENTICATED));
  
        
    } else if (currentUserStatus == QueryStatus.rejected) {
      //This could be  a  situation from last fetch, and not fresh, so check if you are in limbo
      if (appWorkflowState != appWorkflowStates.JUST_AUTHENTICATED_APP_IN_LIMBO) {
        dispatch(setAppWorkflowState(appWorkflowStates.UNAUTHENTICATED));
        dispatch(setCurrentUserData({}));
      }
    }
    setCurrentUserInsertedInState(true);
  }, [currentUser, currentUserStatus, cookieValue, appWorkflowState, dispatch]);

  useEffect(() => {
    if (tokenReady && currentUserStatus != QueryStatus.pending) {
      refetchCurrentUser()
    }
  }, [appWorkflowState, dispatch, tokenReady]);

  const { data: businessParameterList, status: businessParameterListStatus } = useGetAllBusinessParamsListQuery(void 0,{skip: appWorkflowState != appWorkflowStates.AUTHENTICATED});

  const [overlayTitle,setOverlayTitle] = useState('')
  const [overlayContent,setOverlayContent] = useState('')
  useEffect(() => {

    if(appWorkflowState == appWorkflowStates.AUTHENTICATED && businessParameterListStatus == QueryStatus.fulfilled) {
        dispatch(setBusinessParameterList(businessParameterList.data));        
    }
  }, [businessParameterListStatus]);

const { data: appSettings, error, isLoading } = useGetPublicDataQuery({}, { refetchOnMountOrArgChange: false });
const { data: protectedSettings } = useGetProtectedAppSettingsQuery(
  {},
  { 
    skip: appWorkflowState !== appWorkflowStates.AUTHENTICATED,
    refetchOnMountOrArgChange: false 
  }
);
useEffect(() => {
  if (appSettings) {
    dispatch(setPublicAppSetting(appSettings));
  }
  if (protectedSettings && appWorkflowState === appWorkflowStates.AUTHENTICATED) {
    dispatch(setProtectedAppSetting(protectedSettings));
    // if(currentUser.data?.ReleasePopupShown === false){
    getReleaseNotes()
      .unwrap()
      .then((data) => {
        setOverlayTitle(data?.data?.version)
        setOverlayContent(data?.data.notes)
        // if (currentUser?.data?.ReleasePopupShown === false) {
        //   setDisplayOverlay(true);
        // }
      })
    // }
  }
}, [appSettings, protectedSettings, appWorkflowState, dispatch]);

  const handleOverlayAcknowledge = () => {
    if(currentUser.data?.ReleasePopupShown === false)
    {
      resetReleasePopup()
      .unwrap()
      .then((res: any) => {
        // dispatch(setCurrentUserData({
        //   ...currentUser,
        //   data: {
        //     ...currentUser.data,
        //     ReleasePopupShown: true,
        //   }
        // }));
        refetchCurrentUser();
        setDisplayOverlay(false); // Hide overlay
      })
      .catch((err) => {
        console.error("Error resetting popup:", err);
      });
    }
  };
  // Handles refreshing the token
  const TriggerIntervalValue = 60000;
  useInterval(() => {
    const currentTime = new Date();
    const expirationTime = new Date(Number(Cookies.get(FoundationsConstants.TOKEN_EXP_STR))).getTime();
    const currentCookieTokenExp = Cookies.get(FoundationsConstants.TOKEN_EXP_STR);

    const timeDifference = expirationTime - currentTime.getTime();

    if (currentCookieTokenExp) {
      if (timeDifference <= 2 * 60 * 1000 && timeDifference > 0) {
        if (appWorkflowState === appWorkflowStates.AUTHENTICATED && appSettings.data.tokenExpirationInterval) {
          refetchRefreshToken()
            .unwrap()
            .then((res) => {
              if (res?.data) {
                setHLUserCookies(res.data, appSettings.data.tokenExpirationInterval);
              }
            })
            .catch((err) => {
              console.error("Unicorn: Error On Calling Refresh Token", err);
            });
        }
      }
    }
  }, (TriggerIntervalValue));

  useEffect(()=>{
    if (currentUser?.proxyInfo?.isProxyMode) {
      startProxyCheckThread(currentUser.proxyInfo.isProxyMode)
      dispatch(setAppRedirectURL(window.location.hash));
      dispatch(setAppWorkflowState(appWorkflowStates.FORCE_REDIRECT));
    }
    if (currentUser?.data?.ReleasePopupShown === false) {
      setDisplayOverlay(true);
    }
  },[currentUser])

  if (!tokenReady || appWorkflowState == null || appWorkflowState == appWorkflowStates.UNINITIALIZED) return children;
 
  const isAppReady =
  currentUserInsertedInState &&
  (currentUserStatus == QueryStatus.pending ||
   appWorkflowState === appWorkflowStates.AUTHENTICATED ||
   appWorkflowState === appWorkflowStates.UNAUTHENTICATED)
  return <>{isAppReady ? children : null}
    {displayOverlay && currentUser?.data && (
      <Overlay
        title={`Upgrade Release Note(s) ${overlayTitle}`}
        content={overlayContent}
        onAcknowledge={handleOverlayAcknowledge}
        onClose={handleOverlayAcknowledge}
        buttonLabel="Acknowledge"
      />
    )}
  </>;
});

const ReactApp = () => {
  const queryClient = new QueryClient()

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <SetupAppContext>
          <ToastContainer />
          <Router>
            <Routes>
              <Route path="*" element={<AppRouter />} />
            </Routes>
          </Router>
        </SetupAppContext>
      </QueryClientProvider>
    </Provider>
  );
};



export default ReactApp;